import React from 'react';
import { Link } from 'react-router-dom';
import {
    Button,
    Icon,
} from '@material-ui/core';

const AddListingButton = (props) => {  
    return (
        <Link to="/biz/listing/search" className="add-list-2">
            <Button 
                variant="contained"  
                color="secondary"
                endIcon={<Icon>queue</Icon>} 
                size="large"
            >
                Add Business
            </Button>
        </Link>
    );
};

export default AddListingButton;